import { IRouteDetails } from '../../../../../sp-types/routeDetailsType';
import React from 'react';

export const editRouteDetailsUpdateRouteDetail = (
  index: number,
  newData: any,
  setRouteDetails: React.Dispatch<React.SetStateAction<IRouteDetails>>,
) => {
  setRouteDetails((prevDetails) => {
    const updatedDetails = prevDetails.routeDetails.map((detail, idx) =>
      idx === index ? { ...detail, data: newData } : detail,
    );
    return { ...prevDetails, routeDetails: updatedDetails };
  });
};

export const editRouteDetailsUpdateOffset = (
  itemIndex: number,
  newValue: number,
  setRouteDetails: React.Dispatch<React.SetStateAction<IRouteDetails>>,
) => {
  setRouteDetails((prevDetails) => ({
    ...prevDetails,
    routeDetails: prevDetails.routeDetails.map((item, index) =>
      itemIndex === index ? { ...item, offset: newValue } : item,
    ),
  }));
};

export const editRouteDetailsHandleIndexChange = (
  currentIndex: number,
  newIndex: number,
  routeDetailsData: IRouteDetails,
  setRouteDetails: React.Dispatch<React.SetStateAction<IRouteDetails>>,
) => {
  if (newIndex < 0 || newIndex > routeDetailsData.routeDetails.length) {
    return;
  }
  setRouteDetails((prevDetails) => {
    const updatedDetails = [...prevDetails.routeDetails];
    const [movedItem] = updatedDetails.splice(currentIndex, 1);
    updatedDetails.splice(newIndex, 0, movedItem);
    return { ...prevDetails, routeDetails: updatedDetails };
  });
};

export const editRouteDetailsHandleAddComponent = (
  routeDetailsType: string,
  RouteDetailsComponentMap: any,
  setRouteDetails: React.Dispatch<React.SetStateAction<IRouteDetails>>,
) => {
  const newDetail = {
    type: routeDetailsType,
    data: RouteDetailsComponentMap[routeDetailsType].defaultValue,
    offset: 0,
  };

  setRouteDetails((prevDetails) => ({
    ...prevDetails,
    routeDetails: [...prevDetails.routeDetails, newDetail],
  }));
};

export const editRouteDetailsHandleDeleteItem = (
  index: number,
  setRouteDetails: React.Dispatch<React.SetStateAction<IRouteDetails>>,
) => {
  setRouteDetails((prevDetails) => {
    const updatedDetails = [...prevDetails.routeDetails];
    updatedDetails.splice(index, 1);
    return { ...prevDetails, routeDetails: updatedDetails };
  });
};
